import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AsyncSubject } from 'rxjs/AsyncSubject';

import { RcsConnectorIndexDbProvider } from '../rcs-connector-index-db/rcs-connector-index-db';
import { RcsSyncDataProvider } from '../../providers/rcs-sync-data-service/rcs-sync-data-service';
import { RcsStackProvider } from '../rcs-stack-service/rcs-stack-service';

@Injectable()
export class RcsKdDataServiceProvider {

  constructor(
    private db_service: RcsConnectorIndexDbProvider,
    public syncService: RcsSyncDataProvider,
    private stack_service: RcsStackProvider) {}

    private create_ISO_Date(){
      Date.prototype.localISOString = function() {
        var tzo = -this.getTimezoneOffset(),
        dif = tzo >= 0 ? '+' : '-',
        pad = function(num) {
        var norm = Math.floor(Math.abs(num));
        return (norm < 10 ? '0' : '') + norm;
      };
      return this.getFullYear() +
        '-' + pad(this.getMonth() + 1) +
        '-' + pad(this.getDate()) +
        'T' + pad(this.getHours()-2) +
        ':' + pad(this.getMinutes()) +
        ':' + pad(this.getSeconds())
      }
      let sync_date = new Date();
      let date_string = sync_date.localISOString().replace('T', ' ');
      var n = date_string.indexOf('+');
      return date_string.substring(0, n != -1 ? n : date_string.length).split("\\.")[0];
    }

  // Job speichern in der lokalen Datenbank und update zum Odoo-Service
  public save_job(job:any):Observable<any>{
    job.write_date = this.create_ISO_Date();
    return this.db_service.get_record_by_key('login', 'user_login').mergeMap(login => {
      if (localStorage.getItem('online_status') === 'true'){
        //this.draft_service.delete_draft(job.id);
        let submodul_ids = this.syncService.update_job(login, job);
        console.log(submodul_ids);
        return this.syncService.sync_job_after_update(login, job.id, submodul_ids);
      }else{
        return Observable.create(observer => {
          //this.draft_service.save_draft(job, login);
          observer.next(job);
          observer.complete();
        });
      }
    });
  }

  // Legt einen Task an um später im Odoo den Workflow für diesen Job zu starten
  public start_job(job:any):AsyncSubject<any>{
    let async_object = new AsyncSubject();
    this.db_service.get_record_by_key('login', 'user_login').subscribe(
      (login) => {
        this.stack_service.add_task(1, 'workflow_manipulations', [login, 'rcs.kdienst.auftrag', 'begin_work', job.id], job.id);
        job.state_name = 'in Arbeit'
        if (localStorage.getItem("online_status") == 'true'){
          this.stack_service.overwatch_task_processes([job.id]).subscribe(
          success => {
            this.db_service.update_record('jobs', job, job.id);
            async_object.next(job);
            async_object.complete();
          }
        )
      }else{
        async_object.next(job);
        async_object.complete();
      }
    })
    return async_object;
  }

  // Löscht ein Submodul aus dem Odoosystem
  public delete_subrecord(item:string, record_id:number):void{
    this.db_service.get_record_by_key('login', 'user_login').subscribe(
      (login) => {
        this.stack_service.add_task(1, 'delete_record', [login, item, record_id], record_id);
    }, (error) => {console.log(error)});
  }

  // Liest alle Produkte aus der lokalen Datenbank
  public get_products(product_filter):Observable<any>{
    if (product_filter.search_value !== ''){
      return this.db_service.get_record_by_index('products', product_filter.categories, product_filter.search_value);
    }
  }

  // PROTOTYP
  public get_jobs(){
    let kd_db_service = this.db_service;
    let async_object = new AsyncSubject();
    this.db_service.get_database_store().then(function(){
      kd_db_service.get_all_records('jobs').subscribe(
        jobs => {
          async_object.next(jobs);
          async_object.complete();
        }
      );
    })
    return async_object;
  }

  // Liest einen Job anhand seiner ID aus der lokalen Datenbank
  public get_job(id:number):Observable<any>{
    return this.db_service.get_record_by_key('jobs', id);
  }

  // Jobs aus dem Odoo mit der App synchronisieren
  public sync_jobs(){
    if (localStorage.getItem("online_status") == 'true') {
      //this.db_service.clear_collection('jobs');
      return this.db_service.get_record_by_key('login', 'user_login').map(
        login => this.syncService.sync_jobs(login)
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/rcs-kd-data-service/rcs-kd-data-service.ts